import { z } from "zod";
import { calendarDateString } from "./calendar-date.js";
export const GetStepsQuery = z
    .object({
    /** Number of trailing local calendar days, including today. */
    days: z.coerce.number().int().min(1).max(365).default(28),
})
    .default({ days: 28 });
export const StepDay = z.object({
    date: calendarDateString("date"),
    steps: z.number().int().nonnegative().nullable(),
    observedAt: z.string().datetime().nullable(),
});
export const GetStepsResponse = z.object({
    asOf: z.string().datetime(),
    timezone: z.string().nullable(),
    today: StepDay,
    days: z.array(StepDay),
    averages: z.object({
        trailing7Days: z.number().int().nonnegative().nullable(),
        trailing28Days: z.number().int().nonnegative().nullable(),
    }),
});
export const PutStepGoalRequest = z.object({
    targetSteps: z.number().int().min(1_000).max(100_000),
});
export const StepGoalResponse = z.object({
    id: z.string().uuid(),
    targetSteps: z.number().int().positive(),
    startsOn: calendarDateString("startsOn"),
    endsOn: calendarDateString("endsOn").nullable(),
});
export const StepsDashboardDay = z.object({
    date: calendarDateString("date"),
    steps: z.number().int().nonnegative().nullable(),
    distanceMeters: z.number().int().nonnegative().nullable(),
    /** Declared a recovery day, so it bridges the streak instead of breaking it. */
    isRestDay: z.boolean(),
});
/**
 * Whether today is held as a rest day.
 *
 * There is deliberately no allowance here. A member can freeze as often as
 * they need to: HealthOS is a health product, and somebody ill for a week
 * should not have to choose between resting and keeping their streak. A rest
 * day holds the streak rather than extending it, so `streakDays` does not move
 * when one is declared and an unlimited freeze cannot inflate a count.
 */
export const StepRestDayState = z.object({
    todayDeclared: z.boolean(),
});
export const StepRestDayResponse = z.object({
    localDate: calendarDateString("localDate"),
    streakDays: z.number().int().nonnegative(),
    restDay: StepRestDayState,
});
export const GetStepsDashboardResponse = z.object({
    asOf: z.string().datetime(),
    timezone: z.string(),
    needsGoal: z.boolean(),
    goal: z
        .object({
        targetSteps: z.number().int().positive(),
        effectiveFrom: calendarDateString("effectiveFrom"),
    })
        .nullable(),
    today: z.object({
        date: calendarDateString("date"),
        steps: z.number().int().nonnegative(),
        targetSteps: z.number().int().positive().nullable(),
        distanceMeters: z.number().int().nonnegative().nullable(),
        lastSyncedAt: z.string().datetime().nullable(),
    }),
    streakDays: z.number().int().nonnegative(),
    restDay: StepRestDayState,
    days: z.array(StepsDashboardDay),
    /** Highest recorded run across history. Optional during API rollout. */
    bestStreakDays: z.number().int().nonnegative().optional(),
    totals: z.object({
        steps: z.number().int().nonnegative(),
        distanceMeters: z.number().int().nonnegative().nullable(),
        activeDays: z.number().int().nonnegative(),
        bestDaySteps: z.number().int().nonnegative().nullable(),
    }),
});
//# sourceMappingURL=steps.js.map